<template>
  <tr class="rowLastTr sticky">
    <td
        v-for="(item, idx) in headers"
        :key="idx"
        :class="['td',  { 'firstLetter':item, 'tdSticky': item.sticky }]"
    >
      <template v-if="getDisplayTotals(item)">
        <tool-tip
            v-if="getDisplayTotals(item).isTooltip"
            :text="getDisplayTotals(item).tooltip"
            content-class="top"
            :position="{ top: 'top' }"
        >
          <div v-html="getDisplayTotals(item).text"></div>
        </tool-tip>
        <div v-else v-html="getDisplayTotals(item).text "></div>
      </template>
    </td>
  </tr>
</template>

<script>
// components
import ToolTip from "@/shared/ToolTip/ToolTip";
// helpers
import { getSum } from "@/helper/getSum";
import { getCount } from "@/helper/getCount";
import { getUnique } from "@/helper/getUnique";
import { getTotalToolTip } from "@/helper/getTotalToolTip";
import { getTotalDisplay } from "@/helper/getTotalDisplay";
import getDifferenceSum from "@/helper/getDifferenceSum";

export default {
	name: "RowLastTr",
	components: {
		ToolTip
	},
	props: {
		headers: Array,
		listItems: Array,
		isCheckbox: Boolean
	},
	methods: {
		getDisplayTotals({ footer, dollar, miles, gallons, sum, value: keyValue }) {
			let total = null;
			let display = null;

			switch (footer) {
				case 'sumNotCut': {
					total = getSum(this.listItems, keyValue);
					display = Number(total.toFixed(2));
					break;
				}
				case 'sum': {
					total = getSum(this.listItems, keyValue);
					display = getSum(this.listItems, keyValue, 'mod');
					break;
				}
				case 'count': {
					total = getCount(this.listItems);
					display = getCount(this.listItems, keyValue, true);
					break;
				}
				case 'unique': {
					total = getUnique(this.listItems, keyValue);
					display = getUnique(this.listItems, keyValue, true);
					break;
				}
				case 'sumDifference': {
					total = getDifferenceSum(this.listItems);
					display = getDifferenceSum(this.listItems);
					break;
				}
				default: {
					return null;
				}
			}
			const isTooltip = Math.abs(total) >= 1000;
			const tooltip = getTotalToolTip({ totalValue: total, dollar, miles, gallons, sum });
			const text = getTotalDisplay({ totalValue: display, dollar, miles, gallons, sum });

			if (footer) return { keyValue, text, isTooltip, tooltip };
		}
	},
};
</script>
<style lang="scss">
@import "RowLastTrAll.scss";
</style>
<style lang="scss" scoped>
@import "RowLastTr.scss";
</style>
